module.exports = __webpack_public_path__ + "static/img/404.0d03826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404.jpg
// module id = y5XN
// module chunks = 1